export const getCompactAddressLabel = (address) => {
  if (!address) {
    return '';
  }

  const [firstSegment] = address.split(',');

  return firstSegment?.trim() || address;
};

export const getStreetAddressFromGeocodeResult = (geocodeResult) => {
  const components = geocodeResult?.address_components || [];
  const streetNumber = components.find(component => component.types.includes('street_number'))?.long_name;
  const route = components.find(component => component.types.includes('route'))?.long_name;

  if (streetNumber && route) {
    return `${streetNumber} ${route}`;
  }

  return getCompactAddressLabel(geocodeResult?.formatted_address) || null;
};
